<template>
  <div class="me-container" dir="rtl">
    <!-- 返回按钮 -->
    <div class="back-button-container">
      <van-icon
        name="arrow-left"
        class="back-icon"
        size="24px"
        @click="goBack"
      />
    </div>

    <!-- 用户信息头部 -->
    <div class="user-header">
      <div class="user-basic">
        <div class="avatar">
          {{ userAvatar }}
        </div>
        <div class="user-info">
          <h2>{{ userInfo.username }}</h2>
          <div class="user-details">
            <span>{{ userInfo.mail }}</span>
            <span class="divider">|</span>
            <span>{{ userInfo.currency }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 播放记录 -->
    <div class="play-history" ref="playHistoryRef">
      <h3>سجل المشاهدة</h3>
      <div class="play-cards-container" @scroll="handlePlayHistoryScroll">
        <div class="play-cards">
          <div
            v-if="playHistory.length === 0 && !loadingPlayHistory"
            class="no-data"
          >
            لا يوجد سجل مشاهدة
          </div>
          <div
            v-for="(item, index) in playHistory"
            :key="index"
            class="play-card"
            @click="goToPlayerH(item.movieId)"
          >
            <img :src="item.cover" :alt="item.title" />
            <div class="play-info">
              <h4>{{ item.title }}</h4>
              <p>{{ item.lastPlayTime }}</p>
            </div>
          </div>
          <div v-if="loadingPlayHistory" class="loading-more">
            جاري التحميل...
          </div>
        </div>
      </div>
    </div>

    <!-- 支付记录 -->
    <div class="payment-history" ref="paymentHistoryRef">
      <h3>سجل المدفوعات</h3>
      <div class="payment-cards-container" @scroll="handlePaymentScroll">
        <div class="payment-cards">
          <div
            v-if="paymentHistory.length === 0 && !loadingOrders"
            class="no-data"
          >
            لا يوجد سجل مدفوعات
          </div>
          <div
            v-for="(item, index) in paymentHistory"
            :key="index"
            class="payment-card"
          >
            <img :src="item.cover" :alt="item.title" class="payment-cover" />
            <div class="payment-info">
              <h4>{{ item.title }}</h4>
              <div class="payment-details">
                <span class="payment-type">{{
                  getPaymentType(item.type)
                }}</span>
                <span class="payment-amount"
                  >{{ item.payPrice }} {{ item.payCurrency }}</span
                >
              </div>
              <p class="payment-time">{{ item.time }}</p>
            </div>
          </div>
          <div v-if="loadingOrders" class="loading-more">جاري التحميل...</div>
        </div>
      </div>
    </div>

    <!-- 添加退出登录按钮 -->
    <div class="logout-container">
      <van-button class="logout-button" block @click="handleLogout"
        >تسجيل خروج</van-button
      >
    </div>
  </div>
</template>

<script>
import { views, orders } from "../api/api";
import { getUserInfo } from "../utils/index";
export default {
  name: "UserProfile",
  data() {
    return {
      playHistory: [],
      paymentHistory: [],
      playHistoryPage: 1,
      orderPage: 1,
      loadingPlayHistory: false,
      loadingOrders: false,
      hasMorePlays: true,
      hasMoreOrders: true,
    };
  },
  mounted() {
    this.loadPlayHistory();
    this.loadOrders();
  },
  computed: {
    userInfo() {
      return getUserInfo();
    },
    userAvatar() {
      return this.userInfo.mail
        ? this.userInfo.mail.charAt(0).toUpperCase()
        : "?";
    },
  },
  methods: {
    async loadPlayHistory() {
      if (!this.hasMorePlays || this.loadingPlayHistory) return;

      this.loadingPlayHistory = true;
      try {
        const response = await views(this.playHistoryPage, 10);

        if (response.data && response.data.length) {
          this.playHistory = [...this.playHistory, ...response.data];
          this.playHistoryPage++;
        } else {
          this.hasMorePlays = false;
        }
      } catch (error) {
        console.error("加载播放记录失败:", error);
      } finally {
        this.loadingPlayHistory = false;
      }
    },

    async loadOrders() {
      if (!this.hasMoreOrders || this.loadingOrders) return;

      this.loadingOrders = true;
      try {
        const response = await orders(this.orderPage, 10);

        if (response.data && response.data.length) {
          this.paymentHistory = [...this.paymentHistory, ...response.data];
          this.orderPage++;
        } else {
          this.hasMoreOrders = false;
        }
      } catch (error) {
        console.error("加载订单失败:", error);
      } finally {
        this.loadingOrders = false;
      }
    },
    goToPlayerH(movieId) {
      this.$router.push({ name: "PlayerH", query: { id: movieId } });
    },
    handlePlayHistoryScroll(e) {
      const container = e.target;
      // RTL布局下，scrollLeft为负值，需要取绝对值
      const scrollLeft = Math.abs(container.scrollLeft);
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;

      // 当滚动到距离左边界小于100px时加载更多
      if (scrollWidth - (scrollLeft + clientWidth) < 100) {
        this.loadPlayHistory();
      }
    },

    handlePaymentScroll(e) {
      const container = e.target;
      const scrollLeft = Math.abs(container.scrollLeft);
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;

      if (scrollWidth - (scrollLeft + clientWidth) < 100) {
        this.loadOrders();
      }
    },

    getPaymentType(type) {
      const types = {
        2: "شراء الحلقة",
        3: "شراء العضوية",
        // 根据实际类型添加更多映射
      };
      return types[type] || "آخر";
    },
    goBack() {
      this.$router.go(-1); // 返回到上一个页面
    },
    async handleLogout() {
      try {
        // 清除本地存储的用户信息
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token");

        // 跳转到登录页面
        this.$router.replace("/login");
      } catch (error) {
        console.error("退出登录失败:", error);
      }
    },
  },
};
</script>

<style scoped>
.me-container {
  padding: 16px;
  background-color: #f5f5f7;
  min-height: 100vh;
  direction: rtl;
  font-family: "Noto Sans Arabic", sans-serif;
}

.user-header {
  background: white;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.user-basic {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
}

.avatar {
  width: 64px;
  height: 64px;
  background-color: #1890ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  flex-shrink: 0;
}

.user-info {
  margin-right: 16px;
  margin-left: 0;
  text-align: right;
}

.user-info h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.user-details {
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.divider {
  color: #ddd;
  margin: 0 4px;
}

.function-buttons {
  display: flex;
  gap: 15px;
}

.function-buttons button {
  padding: 10px 20px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.function-buttons button:hover {
  background-color: #40a9ff;
}

.play-history,
.payment-history {
  background: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

h3 {
  font-size: 16px;
  color: #333;
  margin-bottom: 12px;
  font-weight: 600;
  text-align: right;
}
.play-cards-container,
.payment-cards-container {
  direction: rtl;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  width: 100%;
}
.play-cards,
.payment-cards {
  display: flex;
  gap: 12px;
  padding: 4px 0 12px;
  flex-direction: row-reverse;
  width: max-content;
}

.play-card {
  min-width: 160px;
  border-radius: 8px;
  overflow: hidden;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.play-card img {
  width: 100%;
  height: 90px;
  object-fit: cover;
}

.play-info {
  padding: 8px;
}

.play-info h4 {
  font-size: 14px;
  margin: 0;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.play-info p {
  margin: 5px 0 0;
  font-size: 12px;
  color: #666;
}

.payment-cards-container {
  margin: 0 -16px;
  padding: 0 16px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  direction: rtl;
}

.payment-cards-container::-webkit-scrollbar {
  display: none;
}

.payment-cards {
  display: flex;
  gap: 12px;
  padding: 4px 0 12px;
  flex-direction: row-reverse;
}

.payment-card {
  min-width: 200px;
  border-radius: 8px;
  overflow: hidden;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.payment-cover {
  width: 100%;
  height: 112px;
  object-fit: cover;
}

.payment-info {
  padding: 12px;
  text-align: right;
}

.payment-info h4 {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.payment-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  flex-direction: row-reverse;
}

.payment-type {
  font-size: 12px;
  color: #666;
  padding: 2px 6px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.payment-amount {
  font-size: 14px;
  font-weight: 500;
  color: #1890ff;
}

.payment-time {
  margin: 8px 0 0;
  font-size: 12px;
  color: #999;
}

.loading-more {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  color: #999;
  font-size: 14px;
}

/* 播放记录加载更多样式 */
.play-cards .loading-more {
  min-width: 100px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 8px;
}

/* 支付记录加载更多样式 */
.payment-cards .loading-more {
  min-width: 100px;
  height: 112px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 8px;
}

.no-data {
  width: 100%;
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
  background: #f5f5f5;
  border-radius: 8px;
}

.back-button-container {
  top: 16px;
  left: 16px;
  z-index: 10;
  text-align: left;
}
.back-icon {
  position: absolute;
  top: 30px;
  right: 20px;
  cursor: pointer;
  z-index: 100;
  transform: rotate(180deg);
}

.logout-container {
  padding: 16px 20px;
  margin-top: 24px;
  margin-bottom: 32px;
}

.logout-button {
  background: linear-gradient(to right, #ff4d4f, #ff7875);
  color: white;
  border: none;
  border-radius: 12px;
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(255, 77, 79, 0.2);
  transition: all 0.3s ease;
  padding: inherit;
}

.logout-button:active {
  background: linear-gradient(to right, #ff7875, #ffa39e);
  transform: translateY(1px);
  box-shadow: 0 2px 8px rgba(255, 77, 79, 0.15);
}

.logout-button::before {
  background-color: transparent !important;
}
</style>
